export default __webpack_public_path__ + "static/media/rock.59910d99.png";